import { connect } from "react-redux";
import { Dispatch } from "redux";
import { IAction } from "reduxsauce";
import { Creators as AllCreators } from "../../actions";
import * as actions from "../../actions/dashboard/dashboard.actions";
import { IState, IUser } from "../../App/reducer";
import { accountId, isAdminUser, organizationName } from "../../selectors/selectors";
import { DashboardComponent, IDashboardDispatchProps, IDashboardStateProps } from "./Dashboard.component";

const Creators = (AllCreators as any).App.Dashboard;

const mapStateToProps = (state: IState): IDashboardStateProps => ({
  accountId: accountId(state),
  allCourseIdsOnDashboard: state.App.Dashboard._.allCourseIdsOnDashboard,
  authenticationState: state.App._.authenticationState,
  classes: state.App.Dashboard._.classes !== null ? state.App.Dashboard._.classes : [],
  courseInstances: state.App.Dashboard._.courseInstances !== null ? state.App.Dashboard._.courseInstances : [],
  courses: state.App.Dashboard._.courses !== null ? state.App.Dashboard._.courses : [],
  editableCourses: state.App.Dashboard._.editableByUser || [],
  failedCoursesIds: state.App.Dashboard._.failedCoursesIds,
  fetchAllDashboardDataRequestError: state.App.Dashboard._.fetchAllDashboardDataRequestError,
  fetchAllDashboardDataRequestState: state.App.Dashboard._.fetchAllDashboardDataRequestState,
  isAdmin: isAdminUser(state),
  loadingMoreCoursesState: state.App.Dashboard._.loadingMoreCoursesState,
  organizationName: organizationName(state),
  scormPackages: state.App.Dashboard._.scormPackages !== null ? state.App.Dashboard._.scormPackages : [],
  user: state.App._.user || ({} as IUser),
});

const mapDispatchToProps = (dispatch: Dispatch<IAction>): IDashboardDispatchProps => ({
  loadAllCourses: () => dispatch(actions.loadAllCourses()),
  loadMoreCourses: () => dispatch(actions.loadMoreCourses()),
  mount: () => {
    dispatch(Creators.mount());
    dispatch(Creators.fetchAllDashboardData());
  },
  searchCourses: (searchInput: string) => dispatch(actions.searchCoursesByName(searchInput)),
  unmount: () => dispatch(Creators.unmount()),
});

export const Dashboard = connect(mapStateToProps, mapDispatchToProps)(DashboardComponent);
